import { AppModalType } from "@faire/deprecated-retailer-visitor-shared/components/MobileAppPromoBanner/AppDownload";
import { ViewAppLink } from "@faire/deprecated-retailer-visitor-shared/components/MobileAppPromoBanner/ViewAppLink";
import { AppsFlyerQRCode } from "@faire/deprecated-retailer-visitor-shared/icons/AppsFlyerQRCode/AppsFlyerQRCode";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

interface IProps {
  appModalType: AppModalType;
}

const QR_CODE_WIDTH = 120;

export const QRAppSection: React.FC<IProps> = (props) => {
  const getQRImageUrl = (): string => {
    if (props.appModalType === AppModalType.APPSTORE) {
      return "https://cdn.faire.com/fastly/3d77d319b263789c7bf9e0d352daa4d5f80ace5d3a1d46f1d532d4c6b7a13c71.png";
    }
    return "https://cdn.faire.com/fastly/9f4d40b9074c96c857d8b582a6eb90d93bae0e7672e670ac4382bdef66c0ca6a.png";
  };

  return (
    <>
      <Typography variant="paragraphSansRegular" align="center">
        <StrictLocalMsg
          id="4yQCZD"
          defaultMessage="Scan this QR code with your mobile phone to download the App."
          description={{
            text: "Message showing a QR code below to download the Faire app linking to an app store",
            img: "https://cdn.faire.com/fastly/aacb3261706fd76b7288bb0596397b81c74108054373e7e547cb1f1be36f8f12.png",
          }}
        />
      </Typography>
      <Spacer height="2x" />
      <Column align="center">
        <AppsFlyerQRCode
          qrCodeWidth={QR_CODE_WIDTH}
          fallbackQrCodeUrl={getQRImageUrl()}
        />
        <Spacer height="2x" />
        <ViewAppLink appModalType={props.appModalType} />
      </Column>
    </>
  );
};
